import {Button, Divider, Form, Row, Space, Typography} from "antd";
import InputType from "components/common/InputType/InputType";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
// import {billDetailColumns3, billDetailColumns4} from "./config";
import "./ListGlass.scss";
// import TableInputAdd from "components/common/TableInputAdd/TableInputAdd";
import {DataTypeColumn} from "types/models/colums-table-type";
import {columns as columnsInit, fieldsPay as fieldsPayInit} from "./config";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import {InputFields} from "components/common";
import {PaidSVG} from "assets";
import {TT_DON_KINH, tabKeys} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {glassKiotService} from "api";
import Notification from "components/common/notification/notification";
import {
  getDetailBillAPI,
  setActiveTabPresciption,
  setDetailBill,
  setShowHoanTra,
  setStatusBill,
  setTypePrescription,
} from "redux/reducer/glassKiot";
import {setActiveKey} from "redux/reducer/common";
import {removeEmpty} from "helper/refraction";
import {LOAI_DON_KINH} from "types/enums/glass";
import {isValuable, randomId, toNumber} from "helper/common";
import {validateMaxMin} from "helper/validate";
import e from "cors";
const ListGlass = forwardRef((props: any, ref) => {
  const [formBill] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [formTable] = Form.useForm();
  const [data, setData] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const idBill = useAppSelector(state => state.glassKiot.idBill);
  const statusBill = useAppSelector(state => state.glassKiot.statusBill);
  const [fieldsPay, setFieldsPay] = useState(fieldsPayInit);
  const [columns, setColumns] = useState(columnsInit);
  const detailBill = useAppSelector(state => state.glassKiot.detailBill);
  const typePrescription = useAppSelector(
    state => state.glassKiot.typePrescription
  );
  const activeTabPresciption = useAppSelector(
    state => state.glassKiot.activeTabPresciption
  );
  const showHoanTra = useAppSelector(state => state.glassKiot.showHoanTra);
  const patientRef = useAppSelector(state => state.glassKiot.patientRef);
  const glassRef = useAppSelector(state => state.glassKiot.glassRef);
  useImperativeHandle(ref, () => ({
    returnBill: () => {
      returnBill();
    },
  }));

  useEffect(() => {
    fieldsPay.find(e => e?.name == "giamGia").onChange = e => {
      setValidateLyDoGiam(e);
      setThanhTien();
    };
    fieldsPay.find(e => e?.name == "tongTien").onChange = e => {
      setThanhTien();
    };
    formBill.setFieldValue("nvBanHang", localStorage.getItem("fullName"));
    getListPayments();
  }, []);
  const setThanhTien = () => {
    const tongTien = toNumber(formBill.getFieldValue("tongTien"));
    const giamGia = toNumber(formBill.getFieldValue("giamGia"));
    const thanhTien = toNumber(tongTien - giamGia);

    formBill.setFieldValue("thanhTien", thanhTien);
  };
  const getListPayments = async () => {
    try {
      const res = await glassKiotService.getListPayments();

      const options = res.data.map(e => ({value: e?.name, label: e?.name}));
      fieldsPay.find(e => e?.name == "paymentsName").options = options;
    } catch (error) {}
  };

  const setTongTien = tongGiaTriDon => {
    formBill.setFieldValue("tongTien", toNumber(tongGiaTriDon));
    setThanhTien();
  };
  const setGiamGia = tongGiamGia => {
    formBill.setFieldValue("giamGia", toNumber(tongGiamGia));
    setThanhTien();
  };

  useEffect(() => {
    if (detailBill) {
      setDataTable(detailBill?.listGlassesSalesDetailDto);
      formBill.setFieldsValue(detailBill?.glassesSalesDto);
      if (detailBill?.glassesSalesDto?.status == TT_DON_KINH.CHUA_BAN) {
        formBill.setFieldValue("nvBanHang", localStorage.getItem("fullName"));
      }
    }
  }, [detailBill]);
  const setDataTable = (list: any[] | []) => {
    setData(list?.map(e => ({...e, tonKho: e?.soLuongTon, key: randomId()})));
    formTable.setFieldValue(
      "listGlassesSalesDetailDto",
      list?.map(e => ({...e, tonKho: e?.soLuongTon, key: randomId()}))
    );
  };
  useEffect(() => {
    dispatch(setStatusBill(null));
    setDataTable([]);
    formBill.resetFields();
  }, [idBill]);
  useEffect(() => {
    if (statusBill == TT_DON_KINH.CHUA_BAN || !statusBill) {
      formBill.setFieldValue("nvBanHang", localStorage.getItem("fullName"));
    }

    fieldsPay.find(e => {
      if (
        e.name === "giamGia" ||
        e.name === "lyDoGiamGia" ||
        e.name === "paymentsName" ||
        e.name === "nvBanHang"
      ) {
        if (statusBill != TT_DON_KINH.CHUA_BAN) {
          e.disable = true;
        } else e.disable = false;
      }
    });
  }, [statusBill, idBill]);
  const getDetailBillValue = async () => {
    try {
      const dataPay = await formBill.validateFields();
      const patientInfo = await patientRef.getFormValue();
      if (patientInfo) {
        const glasses = glassRef?.getFormValue();
        const newGlasses = removeEmpty(glasses);

        const params = {
          glassesSalesDto: {
            ...detailBill?.glassesSalesDto,
            ...patientInfo,
            ...dataPay,
            glassesPrescription: newGlasses?.glassesPrescription,
          },
          listGlassesSalesDetailDto: formTable.getFieldValue(
            "listGlassesSalesDetailDto"
          ),
        };
        return params;
      } else {
        throw {error: "Lỗi"};
      }
    } catch (error) {
      return;
    }
  };
  const payBill = async () => {
    const params = await getDetailBillValue();
    if (params) {
      setLoading(true);
      try {
        const res = await glassKiotService.payBill(params);
        dispatch(setDetailBill(res));
        dispatch(setTypePrescription(LOAI_DON_KINH.DA_TAO));
        dispatch(setStatusBill(TT_DON_KINH.DA_BAN));

        if (isValuable(res?.glassesSalesDto?.id)) {
          dispatch(getDetailBillAPI(res?.glassesSalesDto?.id));
        } else if (isValuable(idBill)) {
          dispatch(getDetailBillAPI(idBill));
        } else {
          throw {error: "Lỗi"};
        }
        dispatch(setStatusBill(TT_DON_KINH.DA_BAN));
        Notification("success", "Đã thanh toán đơn kính thành công");
        setLoading(false);
      } catch (error) {
        Notification("error", error?.response?.data ?? "Đã có lỗi xảy ra");
        setLoading(false);
      }
    }
  };
  const returnBill = async () => {
    if (!showHoanTra) {
      dispatch(setShowHoanTra(true));
    } else {
      try {
        const params = await getDetailBillValue();
        if (params) {
          try {
            const res = await glassKiotService.returnBill(params);
            dispatch(setTypePrescription(LOAI_DON_KINH.DA_TAO));
            dispatch(setStatusBill(TT_DON_KINH.HOAN_LAI));
            dispatch(setDetailBill(res));
            if (isValuable(res?.glassesSalesDto?.id)) {
              dispatch(getDetailBillAPI(res?.glassesSalesDto?.id));
            } else if (isValuable(idBill)) {
              dispatch(getDetailBillAPI(idBill));
            } else {
              throw {error: "Lỗi"};
            }

            // dispatch(setActiveKey(tabKeys.GLASSES.TAB_2));
            Notification("success", "Đã hoàn trả đơn kính");
          } catch (error) {
            Notification(
              "error",
              Notification("error", error?.response?.data ?? "Đã có lỗi xảy ra")
            );
          }
        }
      } catch (error) {
        Notification("error", error?.response?.data ?? "Đã có lỗi xảy ra");

        // dispatch(setLoading(false));
      }
    }
  };
  useEffect(() => {
    dispatch(setShowHoanTra(false));
  }, [idBill]);
  useEffect(() => {
    if (typePrescription == LOAI_DON_KINH.TAO_MOI) {
      dispatch(setStatusBill(TT_DON_KINH.CHUA_BAN));
    }
  }, [typePrescription]);
  useEffect(() => {
    const showHoanTra = () => {
      if (statusBill == TT_DON_KINH.HOAN_LAI) {
        dispatch(setShowHoanTra(true));
      } else {
        dispatch(setShowHoanTra(false));
      }
    };
    showHoanTra();
  }, [statusBill]);

  useEffect(() => {
    const disableFieldHoanTra = () => {
      columnsInit.find(e => e.dataIndex == "soLuongHoanTra").disabled =
        statusBill != TT_DON_KINH.DA_BAN;
      columnsInit.find(e => e.dataIndex == "tongTienHoanTra").disabled =
        statusBill != TT_DON_KINH.DA_BAN;
      setColumns([...columnsInit]);
    };

    disableFieldHoanTra();
  }, [statusBill]);
  useEffect(() => {
    const showFieldHoanTra = () => {
      console.log(showHoanTra);
      columnsInit.find(e => e.dataIndex == "soLuongHoanTra").show = showHoanTra;
      columnsInit.find(e => e.dataIndex == "tongTienHoanTra").show =
        showHoanTra;
      columnsInit.find(e => e.dataIndex == "soLuongHoanTra").rules = showHoanTra
        ? [
            {
              validator: async (_, value) => {
                await validateMaxMin("min", value, 1);
              },
              message: "Số lượng hoàn trả phải lớn hơn 0",
            },
          ]
        : [];
      setColumns([...columnsInit]);
    };
    showFieldHoanTra();
  }, [showHoanTra]);

  const setValidateLyDoGiam = giamGia => {
    fieldsPayInit.find(e => e.name == "lyDoGiamGia").rules = giamGia
      ? [{required: true, message: "Chưa nhập lý do giảm giá"}]
      : [];
    setFieldsPay([...fieldsPayInit]);
  };
  return (
    <div className="container glass-list-in-bill">
      <Space style={{width: "100%"}} direction="vertical" size={"small"}>
        <Typography
          style={{
            fontWeight: "bold",
          }}
        >
          Danh sách kính trong đơn
        </Typography>
        <Divider style={{margin: 12}} />
        <Form form={formTable} labelAlign="left" style={{width: "100%"}}>
          <TableInputAdd
            scroll={{x: 1700}}
            setData={setData}
            data={[...data]}
            column={columns}
            isCheckbox={undefined}
            form={formTable}
            name="listGlassesSalesDetailDto"
            disabled={statusBill != TT_DON_KINH.CHUA_BAN ? true : false}
            setTongTien={setTongTien}
            setGiamGia={setGiamGia}
          ></TableInputAdd>
        </Form>

        <Divider />

        <Form form={formBill}>
          <Row gutter={[8, 16]}>
            <InputFields data={fieldsPay}></InputFields>
          </Row>
          {statusBill == TT_DON_KINH.CHUA_BAN && (
            <Row justify={"end"} style={{marginTop: 12}}>
              <Button
                className="btn-sub"
                icon={<PaidSVG />}
                disabled={data.length <= 0 ? true : false}
                onClick={payBill}
                loading={loading}
              >
                Thanh toán
              </Button>
            </Row>
          )}
        </Form>
      </Space>
    </div>
  );
});
export default ListGlass;
